import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AppConfigService} from "./app-config.service";

interface IErrorTranslationsResponse {
  LanguageCode: string;
  Translations: { [errorType: number]: string };
  Version: string;
}

/**
 * The admin-facing copy for each ErrorType, from the same table the player site reads, so a refused command can say
 * why instead of showing the generic "problem processing your request".
 */
@Injectable({
  providedIn: 'root'
})
export class ErrorTranslationService {
  private http = inject(HttpClient);
  private appConfigService = inject(AppConfigService);
  private translations = new Map<number, string>();
  private requested = false;

  /** Starts the one fetch; call it when a screen opens so the copy is there before anything can fail. */
  load(): void {
    if (this.requested) {
      return;
    }

    this.requested = true;

    // HttpClient directly: the APIService wrappers clear the page's error messages on every request.
    this.http.get<IErrorTranslationsResponse>(`${this.appConfigService.commonApiUrl()}/error-translations/en`).subscribe({
      next: (responseP) => {
        Object.entries(responseP?.Translations ?? {})
          .forEach(([errorTypeP, messageP]) => this.translations.set(Number(errorTypeP), messageP));
      },
      error: () => {
        this.requested = false;
      }
    });
  }

  /** The translated message for a failed API call, or null when it carries no ErrorType this table knows. */
  messageFor(errorP: any): string | null {
    const error_type = errorP?.Error?.ErrorType;

    return error_type == null ? null : this.translations.get(Number(error_type)) ?? null;
  }
}
